import { Tooltip, CircularProgress } from "@mui/joy"
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


function DisponibilidadeIcon(props) {

    if (props.disp == "loading") {
        return <CircularProgress size="sm" />
    } else if (props.disp === true) {
        return <CheckCircleOutlineIcon style={{ color: "green" }} />
    } else if (props.disp === false) {

        return <Tooltip title="Ocorreu um erro">
            <ErrorOutlineIcon style={{ color: "red" }} />
        </Tooltip>
    }
}

export default DisponibilidadeIcon